import {
	observationQueryOptions,
	schedulesQueryOptions,
} from "@/features/observations/api";
import ObservationForm from "@/features/observations/components/ObservationForm";
import { hooks as h } from "@/hooks";
import { createFileRoute } from "@tanstack/react-router";

const EditObservationPage = () => {
	const { diaryId, observationId } = Route.useParams();
	const { observation, schedules } = Route.useLoaderData();

	h.useNav([
		{ label: "Patients", route: { to: "/patients" } },
		{
			route: { to: "/patients/$diaryId", params: { diaryId } },
			label: "Diary",
		},
		{
			route: {
				to: "/diaries/$diaryId/edit/observation/$observationId",
				params: { diaryId, observationId },
			},
			label: "Observation",
		},
	]);
	return (
		<div className="mx-auto py-4 container">
			<h1 className="mb-4 font-semibold text-2xl">Edit Observation</h1>
			<ObservationForm
				diaryId={diaryId}
				observationId={observationId}
				observation={observation}
				schedules={schedules}
			/>
		</div>
	);
};

export const Route = createFileRoute(
	"/_app/diaries/$diaryId/edit/observation/$observationId",
)({
	component: EditObservationPage,
	loader: async ({ context, params }) => {
		const observation = await context?.queryClient.ensureQueryData(
			observationQueryOptions(params.observationId),
		);
		const schedules = await context?.queryClient.ensureQueryData(
			schedulesQueryOptions(),
		);
		return { observation, schedules };
	},
});
